import { render } from "./FranchiseCodes.vue?vue&type=template&id=10b0ce54"
import script from "./FranchiseCodes.vue?vue&type=script&lang=js"
export * from "./FranchiseCodes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__